import { render, staticRenderFns } from "./mysubss.vue?vue&type=template&id=6039fdef&"
import script from "./mysubss.vue?vue&type=script&lang=js&"
export * from "./mysubss.vue?vue&type=script&lang=js&"
import style0 from "./mysubss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports